<template>
  <modal
    height="auto"
    @closed="hideModal"
    :scrollable="true"
    :resizable="true"
    :adaptive="true"
    name="deleteObservationModal"
    transition="pop-out"
  >
    <div
      class="px-4 text-green-800 bg-white border-0 modal-content rounded-0 py-7"
      @click="hideModal"
    >
      <div class="modal-header">
        <div class="float-right" role="button">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 33 33">
            <g
              fill="none"
              fill-rule="evenodd"
              stroke="#212121"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              transform="translate(3 3)"
            >
              <line x1="20" y2="20" />
              <line x2="20" y2="20" />
            </g>
          </svg>
        </div>
      </div>
      <div class="mx-6 modal-body mt-11">
        <h2 class="text-6xl font-light text-center">
          {{ trans.get("strings.observations.edit.delete_observation") }}
        </h2>
        <p class="mt-3 font-light">
          {{ trans.get("strings.observations.edit.will_be_deleted") }}
        </p>
      </div>
      <div class="mt-8 text-center modal-footer mb-14">
        <div>
          <button
            type="button"
            class="text-base btn btn-tracking btn-solid btn-dark-green"
            @click="deleteClicked"
          >
            {{ trans.get("strings.observations.edit.delete_observation") }}
          </button>
        </div>
        <div>
          <button
            type="button"
            class="mt-2 border-transparent btn font-sm btn-tracking"
            @click="hideModal"
          >
            {{ trans.get("strings.observations.edit.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: [],

  data() {
    return {};
  },

  mounted() {
    this.showModal();
  },

  methods: {
    showModal() {
      this.$modal.show("deleteObservationModal");
    },

    hideModal() {
      this.$modal.hide("deleteObservationModal");
      this.$emit("close-modal");
    },

    deleteClicked() {
      this.$emit("delete-observation");
    },
  },
};
</script>
